import React from "react";
import { KatTab, KatTabs } from "@amzn/katal-react";
import { CopyBlock, dracula } from "react-code-blocks";
import {
  CODE_SNIPPET_CONSTANTS,
  createCheckoutSessionCodeSnippet,
  getCheckoutSessionCodeSnippet,
  updateCheckoutSessionCodeSnippet,
  completeCheckoutSessionCodeSnippet,
  finalizeCheckoutSessionCodeSnippet,
  getChargePermissionCodeSnippet,
  updateChargePermissionCodeSnippet,
  closeChargePermissionCodeSnippet,
  getChargeCodeSnippet,
  createChargeCodeSnippet,
  captureChargeCodeSnippet,
  cancelChargeCodeSnippet,
  createRefundCodeSnippet,
  getRefundCodeSnippet,
  deliveryTrackerCodeSnippet,
  getBuyerCodeSnippet,
  getReportsCodeSnippet,
  getReportByIdCodeSnippet,
  createReportCodeSnippet,
  getReportDocumentCodeSnippet
} from "../../CodeSnippetConstants";
import { EventHandler } from '../../utils/customEventHandler'

export class CodeSnippets extends React.Component<{api: string, authValues:any}> {
  
    constructor(props: Readonly<{ api: string, authValues:any }>) {
        super(props);
    }

    state = {
        isDataAvailable : false,
        data : {}
    }

    handleEvent = (event) => {
        if(event.detail.formData) {
            this.setState({
                isDataAvailable : true,
                data: {
                    requestParamaters: event.detail.formData.formData.payload ? event.detail.formData.formData.payload : '',
                    method : event.detail.method,
                    host : event.detail.host,
                    urlFragment : event.detail.urlFragment,
                    authorization : event.detail.signedHeaders.authorization,
                    idempotencyKey : event.detail.signedHeaders['x-amz-pay-idempotency-key'],
                    date : event.detail.signedHeaders['x-amz-pay-date'],
                    region : this.props.authValues.region,
                    pathParam : event.detail.formData.formData.pathParam ? event.detail.formData.formData.pathParam : '',
                    publicKeyId : this.props.authValues.publicKeyId
                }
            });
        }
        else {
            this.setState({
                isDataAvailable : false
            });
        }
    };

    componentDidMount() {
        EventHandler.subscribe('apiEvent', this.handleEvent);
    }

    componentWillUnmount() {
        EventHandler.unsubscribe('apiEvent', this.handleEvent);
    }

    render() {
        // Getting Codes for User Selected API
        const apiCode = this.getApiCode();
        // Looping constants to dynamically create code blocks
        const codeSnippetTabs = CODE_SNIPPET_CONSTANTS.map((key) => (
            <KatTab tabId={key.tabId} label={key.label} key={key.tabId}>
                <CopyBlock
                    text={apiCode[key.label.toLowerCase()]}
                    language={key.language}
                    theme={dracula} // dracula is a UI theme provided by react code blocks library
                />
            </KatTab>
        ));
        // Render the code snippet in UI
        return (
            <div>
                {/* By Default Displaying the 1st Tab in List of Katal Tabs*/}
                <KatTabs selected="1" key={this.props.api}>{codeSnippetTabs}</KatTabs>
            </div>
        );
    }

    // Method used to get the Code Snippet from constant for User selected API
    getApiCode() {
        switch (this.props.api) {
            case "createCheckoutSession":
                return this.state.isDataAvailable ? createCheckoutSessionCodeSnippet(this.state.data) : "";
            case "getCheckoutSession":
                return this.state.isDataAvailable ? getCheckoutSessionCodeSnippet(this.state.data) : "" ;
            case "updateCheckoutSession":
                return this.state.isDataAvailable ? updateCheckoutSessionCodeSnippet(this.state.data) : "";
            case "completeCheckoutSession":
                return this.state.isDataAvailable ? completeCheckoutSessionCodeSnippet(this.state.data) : "";
            case "finalizeCheckoutSession":
                return this.state.isDataAvailable ? finalizeCheckoutSessionCodeSnippet(this.state.data) : "";
            case "getChargePermission":
                return this.state.isDataAvailable ? getChargePermissionCodeSnippet(this.state.data) :  "";
            case "updateChargePermission":
                return this.state.isDataAvailable ? updateChargePermissionCodeSnippet(this.state.data) : "";
            case "closeChargePermission":
                return this.state.isDataAvailable ? closeChargePermissionCodeSnippet(this.state.data) : "";
            case "getCharge":
                return this.state.isDataAvailable ? getChargeCodeSnippet(this.state.data) : "";
            case "createCharge":
                return this.state.isDataAvailable ? createChargeCodeSnippet(this.state.data) : "";
            case "captureCharge":
                return this.state.isDataAvailable ? captureChargeCodeSnippet(this.state.data) : "";
            case "cancelCharge":
                return this.state.isDataAvailable ? cancelChargeCodeSnippet(this.state.data) : "";
            case "createRefund":
                return this.state.isDataAvailable ? createRefundCodeSnippet(this.state.data) : "";
            case "getRefund":
                return this.state.isDataAvailable ? getRefundCodeSnippet(this.state.data) : "";
            case "deliveryTracker":
                return this.state.isDataAvailable ? deliveryTrackerCodeSnippet(this.state.data) : "";
            case 'getBuyer':
                return this.state.isDataAvailable ? getBuyerCodeSnippet(this.state.data) : "";
            case 'getReports':
                return this.state.isDataAvailable ? getReportsCodeSnippet(this.state.data) : "";
            case 'getReportById':
                return this.state.isDataAvailable ? getReportByIdCodeSnippet(this.state.data) : "";
            case 'createReport':
                return this.state.isDataAvailable ? createReportCodeSnippet(this.state.data) : "";
            case 'getReportDocument':
                return this.state.isDataAvailable ? getReportDocumentCodeSnippet(this.state.data) : "";
            default:
                return this.state.isDataAvailable ? createCheckoutSessionCodeSnippet(this.state.data) : "";
        }
    }
}

export default CodeSnippets;
